<template>
  <div
    class="labels"
    :class="{
      reverse: isReversedLayout,
    }"
  >
    <label
      v-if="!isMindAlte"
      class="label"
    >
      裏
    </label>
    <label class="label">
      表
    </label>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
  },
  props: {
    isMindAlte: Boolean,
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      isReversedLayout: "config/getIsReversedLayout",
    }),
  },
  watch: {},
  destroyed () {},
  mounted () {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.labels {
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  &.reverse {
    flex-direction: row-reverse;
  }

  .label {
    display: block;
    flex: 1;
    text-align: center;
    font-weight: bold;
  }
}
</style>
